module.exports = __webpack_public_path__ + "static/media/service-7_old.c87a45af.jpg";